import { ReactElement } from 'react';

import styles from './NewCountBadge.module.scss';

interface NewCountBadgeProps {
  count: string | number;
}

export const NewCountBadge = ({ count }: NewCountBadgeProps): ReactElement => {
  return <p className={styles.badge}>{count}</p>;
};
